module.exports = __webpack_public_path__ + "img/fudai.b09e2ade.jpg";